import axiosInstance from "./Interceptor";

export const loginServ = async (payload) => {
    try {
        const response = await axiosInstance.post(`/login?email=${payload?.email}&password=${payload?.password}`);
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const signUpServ = async (payload) => {
    try {
        const response = await axiosInstance.post('/signup', payload);
        return response?.data?.user;
    } catch (error) {
        throw error;
    }
}

export const verifyUserServ = async (payload) => {
    try {
        const response = await axiosInstance.post('/verify_email', payload);
        return response?.data;
    } catch (error) {
        throw error;
    }
}